import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { authAxios } from "../axios";

export const usePasswordValidateRegister = () => {
  const [state, execute, cancel] = authAxios<void, { _id: ObjectId; code: string; password?: string }, unknown>({
    url: "/password/validate-register",
    method: "POST",
  });

  const callback = useCallback(
    (_id: ObjectId, code: string, password?: string) => {
      return execute({
        data: {
          _id,
          code,
          password,
        },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
